<template>
  <div
    id="c-panel"
    :style="winStyle"
  >
    <div id="c-panel-bg"></div>
    <div class="c-content">
      <div class="pager-title">
        <span>查看试卷</span>
      </div>
      <div class="main-container">
        <div
          class="question"
          v-if="singleCount > 0"
        >
          <div class="question-type">
            <span>单选题</span>
            <span>(共{{ singleCount }}题)</span>
          </div>
          <ul class="question-box">
            <li
              class="question-list"
              v-for="(item,index) in singleQuestion"
              :key="index"
            >
              <div class="question-title">
                <span>{{ index + 1 }}、</span>
                <span>{{ item.content }}</span>
                <span>({{ item.grade }}分)</span>
              </div>
              <div
                :key="option_index"
                class="option"
                v-for="(option, option_index) in item.options"
              >
                <input
                  type="radio"
                  :checked="option.select"
                  disabled
                >
                <div>{{ option.code }}、{{ option.title }}</div>
              </div>
              <div class="right-answer">正确答案：{{ item.right_option }}</div>
            </li>
          </ul>
        </div>
        <div
          class="question"
          v-if="multipleCount > 0"
        >
          <div class="question-type">
            <span>多选题</span>
            <span>(共{{ multipleCount }}题)</span>
          </div>
          <ul class="question-box">
            <li
              class="question-list"
              v-for="(item,index) in multipleQuestion"
              :key="index"
            >
              <div class="question-title">
                <span>{{ index + 1 }}、</span>
                <span>{{ item.content }}</span>
                <span>({{ item.grade }}分)</span>
              </div>
              <div
                :key="option_index"
                class="option"
                v-for="(option, option_index) in item.options"
              >
                <input
                  type="checkbox"
                  :checked="option.select"
                  disabled
                >
                <div>{{ option.code }}、{{ option.title }}</div>
              </div>
              <div class="right-answer">正确答案：{{ item.right_option }}</div>
            </li>
          </ul>
        </div>
        <div
          class="question"
          v-if="judgeCount > 0"
        >
          <div class="question-type">
            <span>多选题</span>
            <span>(共{{ judgeCount }}题)</span>
          </div>
          <ul class="question-box">
            <li
              class="question-list"
              v-for="(item,index) in judgeQuestion"
              :key="index"
            >
              <div class="question-title">
                <span>{{ index + 1 }}、</span>
                <span>{{ item.content }}</span>
                <span>({{ item.grade }}分)</span>
              </div>
              <div
                :key="option_index"
                class="option"
                v-for="(option, option_index) in item.options"
              >
                <input
                  type="radio"
                  :checked="option.select"
                  disabled
                >
                <div>{{ option.code }}、{{ option.title }}</div>
              </div>
              <div class="right-answer">正确答案：{{ item.right_option }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="close">
        <span @click="closeExamResultWindow">关闭</span>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'ExamResult',
  props: ['show', 'closeExamResultWindow', 'id'],
  data () {
    return {
      examData: []
    }
  },
  computed: {
    winStyle () {
      if (this.show === true) {
        this.getExamData()
        return {}
      } else {
        return { display: 'none' }
      }
    },
    singleCount () {
      return this.examData.filter(m => m.questionType === 1).length
    },
    multipleCount () {
      return this.examData.filter(m => m.questionType === 2).length
    },
    judgeCount () {
      return this.examData.filter(m => m.questionType === 3).length
    },
    singleQuestion () {
      return this.examData.filter(m => m.questionType === 1)
    },
    multipleQuestion () {
      return this.examData.filter(m => m.questionType === 2)
    },
    judgeQuestion () {
      return this.examData.filter(m => m.questionType === 3)
    }
  },
  methods: {
    getExamData () {
      this.$http.get('/online_student_exam_get/', {
        params: {
          onlineStudentExamId: this.id
        }
      }).then((data) => {
        if (data.code === '200') {
          this.examData = data.data
        }
      })
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
#c-panel {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1001;
}
#c-panel-bg {
  background: #000;
  opacity: 0.6;
  filter: alpha(opacity=60);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.c-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 780px;
  min-height: 500px;
  margin: 0 auto;
  background: #fff;
  padding: 0 20px 10px;
}
.main-container {
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 10px;
}
.pager-title {
  font-size: 16px;
  padding-left: 10px;
  position: relative;
  margin: 20px 0;
  &::after {
    content: "";
    display: block;
    width: 4px;
    height: 18px;
    background: #0790f8;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 5px;
  }
}
.question {
  margin-bottom: 20px;
}
.question-type {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}
.question-list {
  margin-bottom: 10px;
  .question-title {
    display: flex;
    margin: 10px 0;
  }
  .option {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 5px;
    margin-left: 20px;
    input {
      margin-right: 5px;
    }
  }
  .right-answer {
    color: #128642;
  }
}
.close {
  width: 100%;
  text-align: center;
  margin: 10px 0;
  span {
    padding: 5px 10px;
    background: #ccc;
    border-radius: 5px;
    color: #fff;
  }
}
</style>
